import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import TabsPanelInspeccion from './Asociados/Tabs/TabsPanelInspeccionComponent';
import estilos from './Asociados/Tabs/TabsInspeccionarComponent.module.css'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { ObtenerClientes, obtenerTodasLasRelacionesClientes, obtenerTodoHistorialCliente, obtenerClienteConDetalle }
    from '../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import { insertanexo } from '../../redux/DucksUnidadInspeccion/Fi25anexoDuck';
import { getInformeByIdInstalacion } from '../../redux/DucksUnidadInspeccion/InformeCumplimientoDuck';
import InspectorEnCampoState from './Context/InspectorEnCampoState';

function PanelInspeccion(props) {

    const cliente = props.location.state.state.idclienteSeleccionado;
    const optionTab = props.location.state.state.optionTab;
    const instalacionaux = props.location.state.state.instalacion - 1;
    const instalacion = props.location.state.state.instalacion;
    const verdaderaInstalacion = props.location.state.state.alias;
    const ncomision = props.location.state.state.ncomision;
    const folioui = props.location.state.state.folioui;
    const solicitud = props.location.state.state.solicitud;

    const idinforme = useSelector(store => store.Informe.informe);
    const todo = useSelector(store => store.ModuloConsulta.detalleCliente);
    const dataUser = useSelector(store => store.Usuario.user)
    const [detalles, setDetalles] = React.useState({});
    const [insertListo, setInsertListo] = React.useState(false);

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(obtenerClienteConDetalle(cliente)).then((response) => {
            setDetalles(response.payload)
        }) //todo   
    }, []);

    React.useEffect(() => {
        todo
    }, [todo]);

    React.useEffect(() => {
        if (detalles?.anexocliente) {
            //console.log(detalles?.anexocliente[instalacionaux]?.informaciongeneralinstalacioncliente?.idiformaciongeneralcliente)
            if (insertListo === false) {
                // dispatch(getInformeByIdInstalacion(detalles?.anexocliente[instalacionaux]?.informaciongeneralinstalacioncliente?.idiformaciongeneralcliente))
                //     .then((response) => {
                //         console.log(response.payload.data.data.idfi_25_informecumplimientonom)
                //         const data = {
                //             data: {
                //                 idfi_25_informecumplimientonom: response.payload.data.data.idfi_25_informecumplimientonom,
                //                 idtipoanexo: verdaderaInstalacion.idtipoanexo
                //             }
                //         }
                //         dispatch(insertanexo(data))//anexo
                //     })
                setInsertListo(true)

            }
        } //informe 

    }, [detalles])

    React.useEffect(() => {
        insertListo
    }, [insertListo])

    return (
        <Fragment>
            <div id="inicioTabs" className='mb-5'>
                <h1></h1>
            </div>
            <div className='container-fluid' >
                <div className={`row text-center`}>
                    <div className='col-xs-12'>
                        <h3><strong>Informe de Cumplimiento con la NOM de Instalaciones</strong></h3>
                        <br></br>
                        <h4><strong>
                            {verdaderaInstalacion.idtipoanexo == 1 ? (<>Unidad de Producción:  </>) : verdaderaInstalacion.idtipoanexo == 2 ? (<>Unidad de Envasado: </>) : verdaderaInstalacion.idtipoanexo == 3 ? (<>Unidad de Almacén: </>) : (<></>)}
                        </strong> [ {verdaderaInstalacion.informaciongeneralinstalacioncliente.alias}  ]
                        </h4>
                    </div>
                </div>
                <InspectorEnCampoState>
                    < TabsPanelInspeccion alias={''} detalles={detalles} instalacion={instalacion} inspectorLogeado={dataUser} idinforme={idinforme} verdaderaInstalacion={verdaderaInstalacion} optionTab={optionTab} ncomision={ncomision} folioui={folioui} solicitud={solicitud}></TabsPanelInspeccion>
                </InspectorEnCampoState>
            </div>
        </Fragment >
    );
};


export default withRouter(PanelInspeccion)
